import { render, staticRenderFns } from "./topUserManagementImport.vue?vue&type=template&id=45017a1e&scoped=true"
import script from "./topUserManagementImport.vue?vue&type=script&lang=js"
export * from "./topUserManagementImport.vue?vue&type=script&lang=js"
import style0 from "./topUserManagementImport.vue?vue&type=style&index=0&id=45017a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45017a1e",
  null
  
)

export default component.exports